export default __webpack_public_path__ + "static/media/gold.8f43a809.png";